import { TOGGLE_SIDEBAR, SET_SIDEBAR_SELECTED } from './actionTypes'

export const setToggleSidebar = () => {
    return {
        type : TOGGLE_SIDEBAR,
        info : "Navbar redux action :"
    }
}

export const setSidebarSelected = (value) => {
    return {
        type : SET_SIDEBAR_SELECTED,
        info : "Sidebar selected redux action :"+value,
        value : value
    }
}

// export default setToggleSidebar;